import styled from 'styled-components';

import Help from './Help';

export default styled(Help)`
  padding-bottom: 4px;
`;
